import React, { useState } from "react";
import AdminTrainerForm from "./AdminTrainerForm";

function AdminTrainers({ trainers, onCreate, onUpdate }) {
  const [mode, setMode] = useState("list");
  const [selectedTrainer, setSelectedTrainer] = useState(null);

  const create = async (data) => {
    await onCreate(data);
    setMode("list");
  };

  const update = async (data) => {
    await onUpdate(selectedTrainer.id, data);
    setMode("list");
    setSelectedTrainer(null);
  };

  if (mode === "create") {
    return (
      <AdminTrainerForm onSave={create} onCancel={() => setMode("list")} />
    );
  }

  if (mode === "edit") {
    return (
      <AdminTrainerForm
        trainer={selectedTrainer}
        onSave={update}
        onCancel={() => {
          setMode("list");
          setSelectedTrainer(null);
        }}
      />
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="h5 mb-0">Тренери</h2>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={() => setMode("create")}
        >
          Додати тренера
        </button>
      </div>

      <div className="table-responsive admin-panel__table-wrap">
        <table className="table table-sm table-hover mb-0">
          <thead>
            <tr>
              <th>Ім'я</th>
              <th>Телефон</th>
              <th>Firebase UID</th>
              <th>Статус</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {trainers.map((trainer) => (
              <tr key={trainer.id}>
                <td>{trainer.name || "Без імені"}</td>
                <td>{trainer.phone || "-"}</td>
                <td>{trainer.authUid || "-"}</td>
                <td>{trainer.active === false ? "Вимкнений" : "Активний"}</td>
                <td className="text-right">
                  <button
                    type="button"
                    className="btn btn-link btn-sm"
                    onClick={() => {
                      setSelectedTrainer(trainer);
                      setMode("edit");
                    }}
                  >
                    Редагувати
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!trainers.length ? (
        <div className="admin-panel__empty">Тренерів ще немає.</div>
      ) : null}
    </div>
  );
}

export default AdminTrainers;
